import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import useLenis from "../hooks/useLenis";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { MarqueeStrip } from "../components/MarqueeStrip";
import { Featured } from "../components/Featured";
import { Menu } from "../components/Menu";
import { Story } from "../components/Story";
import { Visit } from "../components/Visit";
import { Footer } from "../components/Footer";

export default function Home() {
  useLenis();
  const [content, setContent] = useState(null);

  useEffect(() => {
    api.get("/content").then((res) => setContent(res.data)).catch(() => {});
  }, []);

  if (!content) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-brand-bg" data-testid="home-loading">
        <div className="h-10 w-10 rounded-full border-2 border-brand-line border-t-brand-primary animate-spin" />
      </div>
    );
  }

  const { settings, menu, categories } = content;

  return (
    <div className="App grain bg-brand-bg text-brand-text" data-testid="home-page">
      <Navbar settings={settings} />
      <Hero settings={settings} />
      <MarqueeStrip settings={settings} />
      <Featured items={menu} />
      <Menu items={menu} categories={categories} />
      <Story settings={settings} />
      <Visit settings={settings} />
      <Footer settings={settings} />
    </div>
  );
}
